import { Paginated } from '@feathersjs/feathers';

export const isPaginated = <T>(paginate: unknown): paginate is Paginated<T> =>
  typeof paginate === 'object'
  && !!paginate && 'data' in paginate
  && 'limit' in paginate
  && 'skip' in paginate
  && Array.isArray(paginate.data);
